module.exports = __webpack_public_path__ + "static/media/climbing_camping_matterhorn.da78cc09.webp";